import { PageContainer, PageHeader, Spread, VStack } from '@/components/Atoms'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/Card'
import { CreateCrtPeriodDetailsDialog } from '@/components/CreateCrtPeriodDetailsDialog'
import PermissionsGuard from '@/components/Guard/PermissionsGuard'
import {
  distributionMarginMixSearchSchema,
  useCreateDistributionMarginMix,
} from '@/hooks/queries/crt/useDistributionMarginMix'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import DistributionMarginMixDataTable from './-components/DistributionMarginMixDataTable'

export const Route = createFileRoute(
  '/_auth/_modules/crt/customer-investments/data-sources/distribution-margin-mix/',
)({
  component: RouteComponent,
  validateSearch: (search) => distributionMarginMixSearchSchema.parse(search),
})

function RouteComponent() {
  const { t } = useTranslation('crt')
  const search = Route.useSearch()
  const [isOpen, setIsOpen] = useState(false)

  const { isPending, mutate } = useCreateDistributionMarginMix({
    queries: search,
    handleOnSuccess: () => setIsOpen(false),
  })

  return (
    <PageContainer>
      <Spread>
        <PageHeader>{t('distributionMarginMix.pageHeader')}</PageHeader>
        <PermissionsGuard required={['crt_distribution_margin_mix_create']}>
          <CreateCrtPeriodDetailsDialog
            isOpen={isOpen}
            onOpenChange={setIsOpen}
            triggerLabel={t('distributionMarginMix.createButton')}
            title={t('createDistributionMarginMixDialog.title')}
            nameLabel={t('createDistributionMarginMixDialog.name.label')}
            namePlaceholder={t('createDistributionMarginMixDialog.name.placeholder')}
            isPending={isPending}
            onSubmit={({ name, description, crtPeriod }) =>
              mutate({ name, description, crtPeriod })
            }
          />
        </PermissionsGuard>
      </Spread>

      <Card>
        <CardHeader>
          <CardTitle>{t('distributionMarginMix.cardTitle')}</CardTitle>
        </CardHeader>

        <CardContent>
          <VStack gap="md">
            <DistributionMarginMixDataTable />
          </VStack>
        </CardContent>
      </Card>
    </PageContainer>
  )
}
